module.exports = __webpack_public_path__ + "static/media/01.67bb7503.jpg";